// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Shallowequal = require("shallowequal");

function sendQuery(graphqlClient, query, send) {
  Promise.resolve(graphqlClient.query(query)).then((function (value) {
            Curry._1(send, /* Result */Block.__(1, [value]));
            return Promise.resolve(/* () */0);
          })).catch((function (error) {
          Curry._1(send, /* Error */Block.__(0, [error]));
          return Promise.resolve(/* () */0);
        }));
  return /* () */0;
}

var component = ReasonReact.reducerComponent("GraphqlQuery");

function make(graphqlClient, query, children) {
  var newrecord = component.slice();
  newrecord[/* willReceiveProps */3] = (function (param) {
      var state = param[/* state */2];
      if (Shallowequal(query.variables, state[/* variables */1])) {
        return state;
      } else {
        sendQuery(graphqlClient, query, param[/* send */4]);
        return state;
      }
    });
  newrecord[/* didMount */4] = (function (param) {
      sendQuery(graphqlClient, query, param[/* send */4]);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (param) {
      return Curry._1(children, param[/* state */2][/* response */0]);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* response : Loading */0,
              /* variables */query.variables
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (action.tag) {
        var data = action[0].data;
        return /* Update */Block.__(0, [/* record */[
                    /* response : Loaded */Block.__(0, [data]),
                    /* variables */state[/* variables */1]
                  ]]);
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* response : Failed */Block.__(1, [action[0]]),
                    /* variables */state[/* variables */1]
                  ]]);
      }
    });
  return newrecord;
}

exports.sendQuery = sendQuery;
exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/graphqlQuery.re
// module id = 312
// module chunks = 0